import React from 'react';
import { Box, Drawer } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Flex } from '@skooldio/skooldio-ui-components-core';
import { useTranslation } from 'react-i18next';

import { Icon, ICON_LIST, Text } from 'Components/Base';
import { COLOR } from 'Components/Theme';

import IndividualUnitDrawerQuizArchetypesTable from './IndividualUnitDrawerQuizArchetypesTable';

export const IndividualUnitDrawer = ({ open, onClose, data }) => {
  const { t } = useTranslation('individualUnit');

  const formatData = data => {
    const row = data?.reduce((acc, item) => {
      acc[item.type] = {
        score: item.score,
        total: item.total,
      };
      return acc;
    }, {});

    return [row];
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box style={{ width: '600px' }}>
        <Flex
          alignItem="center"
          justifyContent="space-between"
          style={{ padding: '16px 24px', borderBottom: `1px solid ${COLOR.divider}` }}
        >
          <Text style={{ fontWeight: 700, fontSize: '20px' }}>{t('EXAMINATION_DETAIL')}</Text>
          <Box width="24px" flexShrink={0} style={{ cursor: 'pointer' }} onClick={onClose}>
            <Icon name={ICON_LIST.CLOSE} size={24} />
          </Box>
        </Flex>
        <Box padding="24px">
          <Box style={{ paddingBottom: '24px', borderBottom: `1px solid ${COLOR.divider}` }}>
            <Flex>
              <Box flexShrink={0} width="100px">
                <Text style={{ fontWeight: 600, fontSize: '16px' }}>{t('SECTION')}:</Text>
              </Box>
              <Box width="100%">
                <Text style={{ fontSize: '16px' }}>{data?.sectionName}</Text>
              </Box>
            </Flex>
            <Flex style={{ marginTop: '16px' }}>
              <Box flexShrink={0} width="100px">
                <Text style={{ fontWeight: 600, fontSize: '16px' }}>{t('MISSION')}:</Text>
              </Box>
              <Box width="100%">
                <Text style={{ fontSize: '16px' }}>{data?.sectionGroupName}</Text>
              </Box>
            </Flex>
            <Flex style={{ marginTop: '16px' }}>
              <Box flexShrink={0} width="100px">
                <Text style={{ fontWeight: 600, fontSize: '16px' }}>{t('SUBSECTION')}:</Text>
              </Box>
              <Box width="100%">
                <Text style={{ fontSize: '16px' }}>{data?.subsectionName}</Text>
              </Box>
            </Flex>
            <Flex style={{ marginTop: '16px' }}>
              <Box flexShrink={0} width="100px">
                <Text style={{ fontWeight: 600, fontSize: '16px' }}>{t('EXAMINATION_SCORE')}:</Text>
              </Box>
              <Box width="100%">
                <Text style={{ fontSize: '16px' }}>
                  {data?.quizResult?.score}/{data?.quizResult?.fullScore}
                </Text>
              </Box>
            </Flex>
          </Box>
          <Box paddingTop="24px">
            <IndividualUnitDrawerQuizArchetypesTable data={formatData(data?.quizArchetypes)} />
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

IndividualUnitDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.object,
};

export default IndividualUnitDrawer;
